import { styled, keyframes } from "@mui/material/styles";

const gradientAnimation = keyframes`
  0% {
    background-position: 0 1600px;
  }
  100% {
    background-position: 1600px 0;
  }
`;

export const RainbowText = styled("span")(({ theme }) => ({
  display: "inline-block",
  background: `linear-gradient(
    to right,
    #F57170,
    #10DDC2,
    #F57170
  )`,
  backgroundSize: "1600px 200px",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",

  animation: `${gradientAnimation} 3s infinite forwards`,
}));
